import { render, staticRenderFns } from "./FinalModule.vue?vue&type=template&id=32f81c14&scoped=true&"
import script from "./FinalModule.vue?vue&type=script&lang=js&"
export * from "./FinalModule.vue?vue&type=script&lang=js&"
import style0 from "./FinalModule.vue?vue&type=style&index=0&id=32f81c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f81c14",
  null
  
)

component.options.__file = "FinalModule.vue"
export default component.exports